"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _react = require("react");
var _cnbuilder = require("cnbuilder");
var _useMounted = _interopRequireDefault(require("@livongo/utilities/hooks/useMounted"));
var _dom = _interopRequireDefault(require("@livongo/utilities/system/dom"));
var _FormElementError = _interopRequireDefault(require("../FormElementError"));
var _CreditCardInputModule = _interopRequireDefault(require("./CreditCardInput.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const CreditCardInput = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    classNameRoot,
    classNameItem,
    testAttrRoot,
    testAttrItem,
    testAttrError,
    stripeSdkUrl,
    stripeApiKey,
    id,
    label,
    helpNode,
    onFocus,
    onBlur,
    onChange
  } = _ref;
  const {
    isMounted
  } = (0, _useMounted.default)();
  const stripeInstance = (0, _react.useRef)(null);
  const cardElement = (0, _react.useRef)(null);
  const cardElementRef = (0, _react.useRef)(null);
  const [elementsError, setElementsError] = (0, _react.useState)(null);
  const onChangeCallback = evt => {
    if (isMounted) {
      var _evt$error;
      setElementsError((evt === null || evt === void 0 ? void 0 : (_evt$error = evt.error) === null || _evt$error === void 0 ? void 0 : _evt$error.message) || null);
    }
    if (onChange) {
      onChange(evt);
    }
  };
  let inputHiddenTimer = null;

  // Resolving Axe issue: the Stripe's hidden input elements shouldn't be focusable
  inputHiddenTimer = setTimeout(() => {
    const inputHidden = document.querySelectorAll('.__PrivateStripeElement-input');
    inputHidden === null || inputHidden === void 0 ? void 0 : inputHidden.forEach(el => {
      el.setAttribute('tabindex', '-1');
      el.setAttribute('disabled', 'true');
      return el;
    });
  }, 1000);
  (0, _react.useEffect)(() => {
    async function setup() {
      if (!window.Stripe) {
        await _dom.default.loadScript({
          src: stripeSdkUrl,
          appendTo: 'body'
        });
      }
      stripeInstance.current = window.Stripe(stripeApiKey);
      if (!cardElement.current) {
        const styles = getComputedStyle(document.documentElement);
        const smallInputDefault = styles.getPropertyValue('--small-input-default-font-size');
        cardElement.current = stripeInstance.current
        // hardcode locale to en-US until support for other languages is agreed upon
        // locale controls error messages as well as placeholders
        // when other languages are added, make sure to pull this value from context
        // and run an update on the context value for Stripe elements to change internally
        .elements({
          locale: 'en-US'
        }).create('card', {
          style: {
            base: {
              fontFamily: styles.getPropertyValue('--small-input-default-font-family'),
              // font-size uses rem in variables and that is not compatible with the Stripe iframe
              // setup (causes huge font) so convert it to px manually
              fontSize: smallInputDefault.includes('rem') ? "".concat(parseFloat(smallInputDefault.replace('rem', '')) * 10, "px") : smallInputDefault,
              color: styles.getPropertyValue('--color-form-text-input-default'),
              '::placeholder': {
                color: styles.getPropertyValue('--color-neutral-on-surface-placeholder')
              }
            },
            invalid: {
              color: styles.getPropertyValue('--color-neutral-surface-inverted'),
              iconColor: styles.getPropertyValue('--color-form-icon-error')
            }
          }
        });
        cardElement.current.mount(cardElementRef.current);
        cardElement.current.addEventListener('change', onChangeCallback);
        if (onFocus) {
          cardElement.current.addEventListener('focus', onFocus);
        }
        if (onBlur) {
          cardElement.current.addEventListener('blur', onBlur);
        }
      }
    }
    setup();
    return () => {
      if (cardElement.current) {
        cardElement.current.unmount();
        cardElement.current.removeEventListener('change', onChangeCallback);
        if (onFocus) {
          cardElement.current.removeEventListener('focus', onFocus);
        }
        if (onBlur) {
          cardElement.current.removeEventListener('blur', onBlur);
        }
        cardElement.current.destroy();
        cardElement.current = null;
      }
      clearTimeout(inputHiddenTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // expose external API methods
  (0, _react.useImperativeHandle)(ref, () => ({
    /**
     * Provides access to the internal Stripe instance.
     *
     * @public
     * @returns {Object} - The Stripe instance.
     */
    getStripe: () => stripeInstance.current,
    /**
     * Provides access to the internal Stripe card element.
     *
     * @public
     * @returns {Object} - The Stripe card element.
     */
    getCardElement: () => cardElement.current,
    /**
     * Creates a Stripe token for the given element.
     *
     * @public
     * @returns {Promise} - The resolved promise with either the token or error information.
     */
    createToken: () => stripeInstance.current.createToken(cardElement.current),
    /**
     * Converts payment information collected by elements into a PaymentMethod object that we pass to our server to use in an API call.
     *
     * @public
     * @param {Object} data - The data to pass to Stripe.
     * @param {String} data.clientSecret - The client secret to setup a customer's payment credentials for future payments.
     * @param {Object} [data.details] - User's information such as name, email, address and phone number.
     * @returns {Promise} - The resolved promise with either the setupIntent or error information.
     */
    confirmCardSetup: _ref2 => {
      let {
        clientSecret,
        details
      } = _ref2;
      return stripeInstance.current.confirmCardSetup(clientSecret, {
        /* eslint-disable camelcase */
        payment_method: _objectSpread({
          card: cardElement.current
        }, details && {
          billing_details: details
        })
        /* eslint-enable camelcase */
      });
    }
  }));
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({
    className: (0, _cnbuilder.cnb)(_CreditCardInputModule.default.root, {
      [_CreditCardInputModule.default.containsError]: elementsError
    }, classNameRoot)
  }, elementsError && {
    'data-invalid-field': true
  }), {}, {
    "data-testid": testAttrRoot,
    children: [/*#__PURE__*/(0, _react.cloneElement)(label, {
      className: (0, _cnbuilder.cnb)(_CreditCardInputModule.default.label, label.props.className),
      htmlFor: id
    }), helpNode && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _CreditCardInputModule.default.helpNode,
      id: "".concat(id, "-help"),
      children: helpNode
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ref: cardElementRef,
      id: id,
      className: (0, _cnbuilder.cnb)(_CreditCardInputModule.default.item, classNameItem),
      "data-testid": testAttrItem
    }), elementsError && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormElementError.default, {
      id: "".concat(id, "-error"),
      testAttr: testAttrError,
      role: "alert",
      "aria-live": "assertive",
      children: elementsError
    })]
  }));
});
CreditCardInput.defaultProps = {
  testAttrRoot: 'credit-card-input-root',
  testAttrItem: 'credit-card-input-item',
  testAttrError: 'credit-card-input-error',
  stripeSdkUrl: 'https://js.stripe.com/v3/'
};
var _default = exports.default = CreditCardInput;